<div class="wrapper">
	<div class="percent">{{ percent }}</div>
	<div [hidden]="!isPercent" class="symbol">%</div>
	<div class="counts">({{ count }} / {{ total }})</div>
</div>
